import { render, staticRenderFns } from "./LiNian.vue?vue&type=template&id=406b1ee6&scoped=true&"
import script from "./LiNian.vue?vue&type=script&lang=js&"
export * from "./LiNian.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406b1ee6",
  null
  
)

export default component.exports